export*from"./kib-tabs-new-item";export*from"./typings";